import * as internalMonacoEditor from 'monaco-editor/esm/vs/editor/editor.api';
export const InternalMonacoEditorOption = internalMonacoEditor.editor.EditorOption;